<template>
  <vx-card class="lg:p-8 w-full lg:w-9/12 fadeInLeft">
    <form @keyup.enter="submitForm">
      <div class="vx-card__title mb-4">
        <h4 class="mb-4">Вход</h4>
        <p>Заполните поля ниже</p>
      </div>

        <div class="mt-6">
          <vs-input
            label="Email:"
            name="email"
            v-model="email"
            v-validate="'required|email'"
            class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>

        <div class="mt-6">
          <password-input
            label="Пароль:"
            name="password"
            v-model="password"
            v-validate="'required|min:8'"
            :error="errors.first('password')"
            class="w-full" />
        </div>

      <div class="flex flex-wrap justify-between items-center mt-10 mb-6">
        <vs-checkbox v-model="remember" class="m-0">Запомнить пароль</vs-checkbox>
        <router-link :to="{name: 'password_recovery'}">Забыли пароль?</router-link>
      </div>
      <div class="flex flex-wrap justify-between items-center">
        <p>Нет аккаунта? <router-link :to="{name: 'registration'}">Регистрация</router-link></p>
        <vs-button @click.prevent="submitForm">Войти</vs-button>
      </div>
    </form>
  </vx-card>
</template>

<script>
import Auth from '../../api/http/models/auth/Auth'
import { mapActions } from 'vuex'
import errorsParsing from '../../mixins/errorsParsing'

export default  {
  data () {
    return {
      email: '',
      password: '',
      remember: true
    }
  },
  mixins: [errorsParsing],
  methods: {
    ...mapActions(['fetchAuthUser']),
    async submitForm () {
      const validate = await this.$validator.validateAll()
      if (validate) {
        const response = await Auth.login({
          email: this.email,
          password: this.password,
          remember: this.remember
        })

        if (response.status === 'success' || response.status === 'already_logged_in') {
          await this.fetchAuthUser()
          if (this.$route.query.verify) {
            // Автоматическое подтверждение почты
            this.$router.push({ name: 'verify', params: {verify: this.$route.query.verify} })
          } else {
            document.location = '/'
          }
        } else if (response.errors) {
          this.errorsParsing(response.errors)
        }
      }
    }
  }
}
</script>
